// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2NnX5","content":"styles_content__3T8FG","flexButton":"styles_flexButton__3u18C","formikErrors":"styles_formikErrors__2pKbN"};